import { Box, Button, Modal, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import TextFieldSimpleComponent from "./TextFieldSimpleComponent";
import DropDownListComponent from "./DropDownListComponent";
import InlineSearchComponent from "./InlineSearchComponent";

const styleModal = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 2,
};

const styleButton = {
    margin: '4px'
};

const DropDownInputPopup = (props: any) => {
    const [modelTemp, setModelTemp] = useState<any>({});
    const [confirmText, setConfirmText] = useState('');
    const [preferences, setPreferences] = useState<any | null>(() => {
        const storedPreferences = localStorage.getItem("preferences");
        return storedPreferences ? JSON.parse(storedPreferences) : [];
    });

    useEffect(() => {
        (async () => {
            
        })();
    }, []);

    const confirmAction = () => {
        props.onConfirmAction(modelTemp[props.valueField ?? 'id']);
        props?.onCloseAction();
    }

    const closeAction = () => props?.onCloseAction();

    return (
        <Modal
            open={props.isOpen}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description">
            <Box sx={styleModal}>
                <Typography id="modal-modal-description" sx={{ mt: 2, fontWeight: 'bold', color: (preferences.darkMode ? 'white' : 'black') }}>  
                    {props.titulo}
                </Typography>
                
                <InlineSearchComponent
                    autoFocus 
                    label={props.label}
                    urlApi={props.urlApi}
                    valueField={props.valueField ?? 'id'}
                    textField={props.textField ?? 'name'}
                    setValueEventCallBack={(val:string) => setConfirmText(val)}
                    model={modelTemp}
                    modelField={props.valueField ?? 'id'} />
                <hr />
                <div>
                    <Button variant="contained" color="info" onClick={confirmAction}>{props.labelConfirm ?? "Confirmar"}</Button>
                    <Button sx={styleButton} variant="outlined" color="info" onClick={closeAction}>{props.labelCancel ?? "Cancelar"}</Button>
                </div>
            </Box>
        </Modal>
    );
}

export default DropDownInputPopup;